<template>
	<div id="specimen">
		<!-- 访问数据 -->
		<div class="specimen_data">
			<div class="data_title">
				<span>访问数据</span>
				<span>更新于：{{ Tiem }}</span>
			</div>
			<div class="data_dataTable">
				<div class="dataTable_today">
					<div class="title">今日数据</div>
					<div class="num">
						<div class="num_visit">
							<div class="visit_num">{{ accessingData.todaynum }}</div>
							<div class="visit_text">访问量</div>
						</div>
						<span class="vertical"></span>
						<div class="num_duration">
							<div class="duration_num">{{ accessingData.todaytime }}</div>
							<div class="duration_text">平均时长</div>
						</div>
					</div>
				</div>
				<div class="dataTable_yesterday">
					<div class="title">昨日数据</div>
					<div class="num">
						<div class="num_visit">
							<div class="visit_num">{{ accessingData.yesterdaynum }}</div>
							<div class="visit_text">访问量</div>
						</div>
						<span class="vertical"></span>
						<div class="num_duration">
							<div class="duration_num">{{ accessingData.yesterdaytime }}</div>
							<div class="duration_text">平均时长</div>
						</div>
					</div>
				</div>
				<div class="dataTable_sum">
					<div class="title">总数据</div>
					<div class="num">
						<div class="num_visit">
							<div class="visit_num">{{ accessingData.totalnum }}</div>
							<div class="visit_text">访问量</div>
						</div>
						<span class="vertical"></span>
						<div class="num_duration">
							<div class="duration_num">{{ accessingData.totatime }}</div>
							<div class="duration_text">平均时长</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<statistics></statistics>
	</div>
</template>

<script>
import statistics from './statistics.vue';

export default {
	components: {
		statistics
	},
	data() {
		return {
			Tiem: '', //项目更新时间
			projectId: '', //项目id
			sampleCode: '', //样本编号
			accessingData: {} //访问数据
		};
	},
	computed: {
		prCode() {
			return this.$store.state.pr_Code;
		},
		sCode() {
			return this.$store.state.s_Code;
		}
	},
	watch: {
		prCode(newId, oldId) {
			if (newId) {
				this.projectId = newId;
				this.loadData();
			}
		},
		sCode(newId, oldId) {
			if (newId) {
				this.sampleCode = newId;
			}
		}
	},
	mounted() {
		this.projectId = this.$store.state.pr_Code == '' ? window.localStorage.getItem('prCode') : this.$store.state.pr_Code;
		this.sampleCode = this.$store.state.s_Code == '' ? window.localStorage.getItem('sCode') : this.$store.state.s_Code;
		console.log(this.projectId, this.sampleCode);
		this.loadData();
	},
	methods: {
		loadData() {
			if (this.projectId == '' || this.projectId == null) {
				this.$message.error('请先选择项目');
				return false;
			}
			this.presentTiem();
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.statisticsInterviewlog}`,
				data: {
					prCode: this.projectId,
					sampleCode: this.sampleCode
				},
				cb(res) {
					if (res.result == '111111111111') {
						console.log(res.data);
						res.data.todaytime = that.s_to_hs(res.data.todaytime);
						res.data.yesterdaytime = that.s_to_hs(res.data.yesterdaytime);
						res.data.totatime = that.s_to_hs(res.data.totatime);
						that.accessingData = res.data;
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		s_to_hs(s) {
			//计算分钟
			//算法：将秒数除以60，然后下舍入，既得到分钟数
			var h;
			h = Math.floor(s / 60);
			//计算秒
			//算法：取得秒%60的余数，既得到秒数
			s = s % 60;
			//将变量转换为字符串
			h += '';
			s += '';
			//如果只有一位数，前面增加一个0
			h = h.length == 1 ? '0' + h : h;
			s = s.length == 1 ? '0' + s : s;
			return h + '分' + s + '秒';
		},
		// 更新时间
		presentTiem() {
			var d = new Date();
			let str = '';
			str += d.getFullYear() + '-'; //获取当前年份
			str += d.getMonth() + 1 + '-'; //获取当前月份（0——11）
			str += d.getDate() + ' ';
			str += d.getHours() + ' : ';
			let h = d.getMinutes().toString();
			str += h.length == 1 ? '0' + h + ' : ' : h + ' : ';
			// str += d.getSeconds() + '秒';
			let s = d.getSeconds().toString();
			str += s.length == 1 ? '0' + s : s;
			this.Tiem = str;
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
#specimen {
	// width: 1200px;
	// margin:0 auto;
	height: 100%;
	.specimen_data {
		margin-top: 10px;
		.data_title {
			display: flex;
			justify-content: space-between;
		}
		.data_dataTable {
			width: 100%;
			height: 200px;
			margin-top: 20px;
			background-color: #ffffff;
			display: flex;
			justify-content: space-around;
			.dataTable_today {
				.title {
					margin-top: 37px;
					text-align: center;
					margin-left: -20px;
				}
				.num {
					margin-top: 43px;
					display: flex;
					justify-content: space-between;
					.num_visit {
						padding-right: 67px;
						.visit_num {
							font-size: 28px;
							color: #33a83b;
						}
						.visit_text {
							font-size: 14px;
							color: #333333;
							margin-top: 22px;
						}
					}
					.vertical {
						width: 1px;
						height: 74px;
						background-color: #e1e1e1;
					}
					.num_duration {
						padding-left: 37px;
						.duration_num {
							font-size: 28px;
							color: #33a83b;
						}
						.duration_text {
							font-size: 14px;
							color: #333333;
							margin-top: 22px;
							text-align: center;
						}
					}
				}
			}
			.dataTable_yesterday {
				.title {
					margin-top: 37px;
					text-align: center;
					margin-left: -20px;
				}
				.num {
					margin-top: 43px;
					display: flex;
					justify-content: space-between;
					.num_visit {
						padding-right: 67px;
						.visit_num {
							font-size: 28px;
							color: #0080ff;
						}
						.visit_text {
							font-size: 14px;
							color: #333333;
							margin-top: 22px;
						}
					}
					.vertical {
						width: 1px;
						height: 74px;
						background-color: #e1e1e1;
					}
					.num_duration {
						padding-left: 37px;
						.duration_num {
							font-size: 28px;
							color: #0080ff;
						}
						.duration_text {
							font-size: 14px;
							color: #333333;
							margin-top: 22px;
							text-align: center;
						}
					}
				}
			}
			.dataTable_sum {
				.title {
					margin-top: 37px;
					text-align: center;
					margin-left: -20px;
				}
				.num {
					margin-top: 43px;
					display: flex;
					justify-content: space-between;
					.num_visit {
						padding-right: 67px;
						.visit_num {
							font-size: 28px;
							color: #ed7d39;
						}
						.visit_text {
							font-size: 14px;
							color: #333333;
							margin-top: 22px;
						}
					}
					.vertical {
						width: 1px;
						height: 74px;
						background-color: #e1e1e1;
					}
					.num_duration {
						padding-left: 37px;
						.duration_num {
							font-size: 28px;
							color: #ed7d39;
						}
						.duration_text {
							font-size: 14px;
							color: #333333;
							margin-top: 22px;
							text-align: center;
						}
					}
				}
			}
		}
	}
}
</style>
